import { useState, useEffect } from 'react';
import { doc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';

export const useLinkedInZernio = () => {
  const [meta, setMeta] = useState(null);
  const [followerStats, setFollowerStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubMeta = onSnapshot(
      doc(db, 'socialMetrics', 'linkedin'),
      (snap) => { setMeta(snap.exists() ? snap.data() : null); setLoading(false); },
      (err) => { console.error('LinkedIn (Zernio) meta listener:', err); setLoading(false); }
    );
    const unsubStats = onSnapshot(
      query(collection(db, 'socialMetrics', 'linkedin', 'followerStats'), orderBy('date', 'desc'), limit(7)),
      (snap) => setFollowerStats(snap.docs.map((d) => d.data())),
      (err) => console.error('LinkedIn (Zernio) followerStats listener:', err)
    );
    return () => { unsubMeta(); unsubStats(); };
  }, []);

  const current = followerStats[0]?.followers ?? null;
  const oldest = followerStats.length > 1 ? followerStats[followerStats.length - 1]?.followers ?? null : null;
  const delta = current != null && oldest != null ? current - oldest : null;

  return { data: meta ? { ...meta, currentFollowers: current, followerDelta7d: delta } : null, loading };
};
